import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";

export async function playDriverSuccessFeedback() {
  try {
    if (Capacitor.isNativePlatform()) {
      await Haptics.notification({ type: NotificationType.Success });
      await Haptics.impact({ style: ImpactStyle.Light });
      return { status: "native_haptic" };
    }
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(18);
      return { status: "web_vibrate" };
    }
  } catch (error) {
    return { status: "feedback_failed", error };
  }
  return { status: "noop" };
}
